export default "__VITE_ASSET__lyVd2kSz__";